import VeeValidate, { Validator } from 'vee-validate';
import it from 'vee-validate/dist/locale/It';

// Merge the locales.
Validator.localize({ it: it })

// CUSTOM RULES:

// NOT USE TEMPORARY EMAIL
const emailTemporaryArray = ['10minutemail.com','163.com','1chuan.com','1zhuan.com','20minutemail.com','21cn.com','2prong.com','30minutesmail.com','4warding.com','4warding.com','4warding.net','4warding.org','675hosting.com','675hosting.net','675hosting.org','6url.com','75hosting.com','75hosting.net','75hosting.org','afrobacon.com','ajaxapp.net','amiri.net','amiriindustries.com','anonymail.dk','anonymbox.com','aol.com','bambooclub.cn','binkmail.com','blogmyway.org','bobmail.info','bofthew.com','bsnow.net','bugmenot.com','bumpymail.com','buyusedlibrarybooks.org','centermail.com','centermail.net','choicemail1.com','chongsoft.cn','chongsoft.com','chongsoft.org','cool.fr.nf','courriel.fr.nf','csoftmail.cn','deadspam.com','despam.it','despammed.com','discardmail.com','discardmail.de','dispose.it','disposeamail.com','dispostable.com','dodgeit.com','dodgit.com','dontreg.com','dontsendmespam.de','dotmsg.com','dumpandjunk.com','dumpmail.de','dunflimblag.mailexpire.com','e4ward.com','emaildienst.de','emailias.com','emailmiser.com','emailtemporanea.net','emailto.de','emailxfer.com','emz.net','enterto.com','etranquil.com','etranquil.net','etranquil.org','fakeinformation.com','fakemailz.com','fastacura.com','fastchevy.com','fastchrysler.com','fastkawasaki.com','fastmazda.com','fastmitsubishi.com','fastnissan.com','fastsubaru.com','fastsuzuki.com','fasttoyota.com','fastyamaha.com','filzmail.com','filzmail.com','footard.com','forgetmail.com','front14.org','fuckingduh.com','fux0ringduh.com','getonemail.com','ghosttexter.de','gishpuppy.com','gowikibooks.com','gowikicampus.com','gowikicars.com','gowikifilms.com','gowikigames.com','gowikimusic.com','gowikinetwork.com','gowikitravel.com','gowikitv.com','greensloth.com','guerrillamail.com','guerrillamail.net','guerrillamailblock.com','h8s.org','haltospam.com','hatespam.org','hidemail.de','hush.ai','i-b2c.com','iheartspam.org','imstations.com','incognitomail.net','ipoo.org','iwi.net','jetable.com','jetable.fr.nf','jetable.fr.nf','jetable.net','jetable.org','jnxjn.com','justonemail.net','kasmail.com','killmail.com','killmail.net','klassmaster.com','klassmaster.net','klzlk.com','legworld.cn','letmymail.com','lhsdv.com','link2mail.net','lortemail.dk','lovemeleaveme.com','lroid.com','mail.ru','mail2rss.org','mail333.com','mailblocks.com','mailcatch.com','maileater.com','mailexpire.com','mailfreeonline.com','mailin8r.com','mailinator.com','mailinator2.com','mailmetrash.com','mailmoat.com','mailnesia.com','mailnull.com','mailquack.com','mailshell.com','mailsiphon.com','mailslapping.com','mailtemp.net','mailzilla.com','mega.zik.dj','mega.zik.dj','meinspamschutz.de','meltmail.com','messagebeamer.de','mintemail.com','moncourrier.fr.nf','monemail.fr.nf','monmail.fr.nf','mt2009.com','myspaceinc.com','myspaceinc.net','myspaceinc.org','myspacepimpedup.com','myspamless.com','mytrashmail.com','neomailbox.com','nepwk.com','nervmich.net','nervtmich.net','netmails.com','netmails.net','netzidiot.de','nobulk.com','noclickemail.com','nomail.xl.cx','nospam.ze.tc','nospamfor.us','nurfuerspam.de','nwldx.com','onemoremail.net','oneoffemail.com','oneoffmail.com','oopi.org','ourklips.com','outlawspam.com','owlpic.com','pancakemail.com','pc1520.com','pimpedupmyspace.com','pjjkp.com','poofy.org','pookmail.com','privacy.net','prtnx.com','punkass.com','recyclemail.dk','rejectmail.com','rklips.com','safersignup.de','seorj.cn','sharklasers.com','shiftmail.com','shortmail.net','sibmail.com','sina.com','siteposter.net','slaskpost.se','slopsbox.com','sneakemail.com','sofimail.com','sofort-mail.de','sogetthis.com','sohu.com','spam.la','spam.su','spamavert.com','spambob.com','spambob.net','spambob.org','spambog.com','spambog.de','spambox.us','spamcon.org','spamcorptastic.com','spamday.com','spamex.com','spamexperts.com','spamfree24.com','spamfree24.net','spamfree24.org','spamgourmet.com','spamhole.com','spamhouse.com','spamify.com','spaminator.de','spaml.com','spammotel.com','spamoff.de','spamslicer.com','spamsphere.com','spamtrail.com','speed.1s.fr','teleworm.com','tempemail.net','tempinbox.com','tempmail.it','tempomail.fr','temporarily.de','temporaryforwarding.com','temporaryinbox.com','thankyou2010.com','tom.com','tracciabi.li','trash2009.com','trashdevil.com','trashdevil.de','trashmail.com','trashmail.de','trash-mail.de','trashmail.net','trashmail.org','trashymail.com','turual.com','twinmail.de','tyldd.com','uggsrock.com','upliftnow.com','uplipht.com','uymail.com','venompen.com','viditag.com','viewcastmedia.com','viewcastmedia.net','viewcastmedia.org','visit.onlatedotcom.info','walala.org','wegwerfadresse.de','wetrainbayarea.com','wetrainbayarea.org','wh4f.org','whopy.com','wilemail.com','willselfdestruct.com','wormseo.cn','wuzup.net','wwwnew.eu','xagloo.com','xemaps.com','xents.com','xmaily.com','yep.it','yopmail.com','yopmail.fr','yopmail.fr','yopmail.net','youumail.com','zoemail.org','MakeMeTheKing.com','tempemail.co.za','mail-temp.com','emailthrow.net ','rppkn.com','incognitomail.org','email60.com','rtrtr.com']
const temporaryEmail = {
    getMessage: field => 'Le email temporanee non sono consentite',
    validate(value) {
		var domain = value.split('@');
	    var count = domain.length
	    domain = domain[count-1]
	    if( emailTemporaryArray.indexOf(domain) !== -1){
	    	return false
	    }else{
	    	return true
	    }
    }
}
Validator.extend('temporaryEmail', temporaryEmail);
it.messages = Object.assign({}, it.messages, { temporaryEmail: field => `Le email temporanee non sono consentite` });



// PASSWORD SECURITY CHECK
const checkImei = {
    getMessage: field => 'Codice IMEI non valido.',
    validate(value) {
		var use_checksum = true
		var sum = 0
		if ( jQuery.type(value) === "string" ) {
			if ( value.match('^[0-9]{15}$')) {
				if (!use_checksum) return true;

				for (var i = 0, sum = 0; i < 14; i++) {
					var tmp = value[i] * ((i%2) + 1 );
					sum += (tmp%10) + parseInt(tmp/10);
				}
				return (((10 - (sum%10)) %10) == value[14]);
			}else{
				if ( value == '' ){
					return true
				}else{
					return false
				}
			}
		}else{
			if ( value == '' ){
				return true
			}else{
				return false
			}
		}
    }
}
Validator.extend('checkImei', checkImei);
it.messages = Object.assign({}, it.messages, { checkImei: field => 'Codice IMEI non valido.' });


// EMAIL CHECK PLUS + CHARACTER ( FOR GMAIL....+1@gmail.com )
const plusIssueEmail = {
    getMessage: field => 'L`indirizzo email contiene caratteri non consentiti',
    validate(value) {
		var str = value;
		if (str.indexOf('+') == -1) {
			return true
		}else{
			return false
		}
    }
}
Validator.extend('plusIssueEmail', plusIssueEmail);
it.messages = Object.assign({}, it.messages, { plusIssueEmail: field => 'L`indirizzo email contiene caratteri non consentiti' });

// PASSWORD SECURITY CHECK
const passwordCheck = {
    getMessage: field => 'La password deve essere composta da lettere e numeri.',
    validate(value) {
		if (!/[a-z]/.test(value)) {
			return false;
		} else if (!/[0-9]/.test(value)) {
			return false;
		}
		return true;
    }
}
Validator.extend('passwordCheck', passwordCheck);
it.messages = Object.assign({}, it.messages, { passwordCheck: field => 'La password deve essere composta da lettere e numeri.' });

// PASSWORD SECURITY CHECK
const emptyTime = {
    getMessage: field => 'Il campo Ora è richiesto.',
    validate(value) {
		if ( value.HH == '' || value.mm == '' ) {
			return false;
		}
		return true;
    }
}
Validator.extend('emptyTime', emptyTime);
it.messages = Object.assign({}, it.messages, { emptyTime: field => 'Il campo Ora è richiesto.' });

// NEW VALIDATE RULE FOR PARTITA IVA
const partitaIva = {
    getMessage: field => 'Partita IVA non valida',
    validate(value) {
		var pi = value
		if ( pi.length == 11 ){

			var s = 0;
			for( i = 0; i <= 9; i += 2 )
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			for(var i = 1; i <= 9; i += 2 ){
				var c = 2*( pi.charCodeAt(i) - '0'.charCodeAt(0) );
				if( c > 9 )  c = c - 9;
				s += c;
			}
			var atteso = ( 10 - s%10 )%10;
			if( atteso != pi.charCodeAt(10) - '0'.charCodeAt(0) ){
				return false
			}
			else{
				return true
			}
		}else {
			return true
		}
    }
}
Validator.extend('partitaIva', partitaIva);
it.messages = Object.assign({}, it.messages, { partitaIva: field => 'Partita IVA non valida.' });


// IBAN CHECK
const ibanControl = {
    getMessage: field => 'Il campo Iban non é corretto.',
    validate(value) {

	// Remove spaces and to upper case
	var iban = value.replace( / /g, "" ).toUpperCase(),
		ibancheckdigits = "",
		leadingZeroes = true,
		cRest = "",
		cOperator = "",
		countrycode, ibancheck, charAt, cChar, bbanpattern, bbancountrypatterns, ibanregexp, i, p;

	// Check for IBAN code length.
	// It contains:
	// country code ISO 3166-1 - two letters,
	// two check digits,
	// Basic Bank Account Number (BBAN) - up to 30 chars
	var minimalIBANlength = 5;
	if ( iban.length < minimalIBANlength ) {
		return false;
	}

	// Check the country code and find the country specific format
	countrycode = iban.substring( 0, 2 );
	bbancountrypatterns = {
		"AL": "\\d{8}[\\dA-Z]{16}",
		"AD": "\\d{8}[\\dA-Z]{12}",
		"AT": "\\d{16}",
		"AZ": "[\\dA-Z]{4}\\d{20}",
		"BE": "\\d{12}",
		"BH": "[A-Z]{4}[\\dA-Z]{14}",
		"BA": "\\d{16}",
		"BR": "\\d{23}[A-Z][\\dA-Z]",
		"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
		"CR": "\\d{17}",
		"HR": "\\d{17}",
		"CY": "\\d{8}[\\dA-Z]{16}",
		"CZ": "\\d{20}",
		"DK": "\\d{14}",
		"DO": "[A-Z]{4}\\d{20}",
		"EE": "\\d{16}",
		"FO": "\\d{14}",
		"FI": "\\d{14}",
		"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
		"GE": "[\\dA-Z]{2}\\d{16}",
		"DE": "\\d{18}",
		"GI": "[A-Z]{4}[\\dA-Z]{15}",
		"GR": "\\d{7}[\\dA-Z]{16}",
		"GL": "\\d{14}",
		"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
		"HU": "\\d{24}",
		"IS": "\\d{22}",
		"IE": "[\\dA-Z]{4}\\d{14}",
		"IL": "\\d{19}",
		"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
		"KZ": "\\d{3}[\\dA-Z]{13}",
		"KW": "[A-Z]{4}[\\dA-Z]{22}",
		"LV": "[A-Z]{4}[\\dA-Z]{13}",
		"LB": "\\d{4}[\\dA-Z]{20}",
		"LI": "\\d{5}[\\dA-Z]{12}",
		"LT": "\\d{16}",
		"LU": "\\d{3}[\\dA-Z]{13}",
		"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
		"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
		"MR": "\\d{23}",
		"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
		"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
		"MD": "[\\dA-Z]{2}\\d{18}",
		"ME": "\\d{18}",
		"NL": "[A-Z]{4}\\d{10}",
		"NO": "\\d{11}",
		"PK": "[\\dA-Z]{4}\\d{16}",
		"PS": "[\\dA-Z]{4}\\d{21}",
		"PL": "\\d{24}",
		"PT": "\\d{21}",
		"RO": "[A-Z]{4}[\\dA-Z]{16}",
		"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
		"SA": "\\d{2}[\\dA-Z]{18}",
		"RS": "\\d{18}",
		"SK": "\\d{20}",
		"SI": "\\d{15}",
		"ES": "\\d{20}",
		"SE": "\\d{20}",
		"CH": "\\d{5}[\\dA-Z]{12}",
		"TN": "\\d{20}",
		"TR": "\\d{5}[\\dA-Z]{17}",
		"AE": "\\d{3}\\d{16}",
		"GB": "[A-Z]{4}\\d{14}",
		"VG": "[\\dA-Z]{4}\\d{16}"
	};

	bbanpattern = bbancountrypatterns[ countrycode ];

	// As new countries will start using IBAN in the
	// future, we only check if the countrycode is known.
	// This prevents false negatives, while almost all
	// false positives introduced by this, will be caught
	// by the checksum validation below anyway.
	// Strict checking should return FALSE for unknown
	// countries.
	if ( typeof bbanpattern !== "undefined" ) {
		ibanregexp = new RegExp( "^[A-Z]{2}\\d{2}" + bbanpattern + "$", "" );
		if ( !( ibanregexp.test( iban ) ) ) {
			return false; // Invalid country specific format
		}
	}

	// Now check the checksum, first convert to digits
	ibancheck = iban.substring( 4, iban.length ) + iban.substring( 0, 4 );
	for ( i = 0; i < ibancheck.length; i++ ) {
		charAt = ibancheck.charAt( i );
		if ( charAt !== "0" ) {
			leadingZeroes = false;
		}
		if ( !leadingZeroes ) {
			ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf( charAt );
		}
	}

	// Calculate the result of: ibancheckdigits % 97
	for ( p = 0; p < ibancheckdigits.length; p++ ) {
		cChar = ibancheckdigits.charAt( p );
		cOperator = "" + cRest + "" + cChar;
		cRest = cOperator % 97;
	}
	return cRest === 1;
    }
}
Validator.extend('ibanControl', ibanControl);
it.messages = Object.assign({}, it.messages, { ibanControl: field => 'Il campo Iban non é corretto.' });

// IBAN ITALIAN
const ibanItalian = {
    getMessage: field => 'Non si tratta di un iban italiano.',
    validate(value) {
		if ( value == '' ){
			return true
		}else{
			if (  value ){

				var lower = value.toLowerCase()

				//console.log( lower.indexOf("it") )
				if ( lower.indexOf("it") == 0 ){
					return true
				}else{
					return false
				}

			}else{
				return true
			}
		}
    }
}
Validator.extend('ibanItalian', ibanItalian);
it.messages = Object.assign({}, it.messages, { ibanItalian: field => 'Non si tratta di un iban italiano.' });



// NEW VALIDATE RULE FOR IBAN
const ibanPoste = {
    getMessage: field => 'IBAN inserito non risulta essere un IBAN di Poste Italiane',
    validate(value) {
      // Remove spaces and to upper case
    	var iban = value.replace( / /g, "" ).toUpperCase()
      if( iban.substring(5, 10) == '07601' ){
        return true
      }else{
        return false
      }
    }
}

Validator.extend('ibanPoste', ibanPoste);
it.messages = Object.assign({}, it.messages, { ibanPoste: field => 'IBAN inserito non risulta essere un IBAN di Poste Italiane .' });

// PASSWORD SECURITY CHECK
const codiceFiscale = {
    getMessage: field => 'Codice Fiscale non valido.',
    validate(value) {
          var cf = value
          var validi, i, s, set1, set2, setpari, setdisp;
          if( cf == '' ){
            return '';
          }
          cf = cf.toUpperCase();

          if( cf.length != 16 ){
            return false;
          }

          validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
          for( i = 0; i < 16; i++ ){
              if( validi.indexOf( cf.charAt(i) ) == -1 ){
                return false;
              }

          }
          set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
          setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
          s = 0;
          for( i = 1; i <= 13; i += 2 ){
            s += setpari.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
          }

          for( i = 0; i <= 14; i += 2 ){
            s += setdisp.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));
          }

          if( s%26 != cf.charCodeAt(15)-'A'.charCodeAt(0) )
          {
            return false;
          }else{
            return true;
          }



    }
}
Validator.extend('codiceFiscale', codiceFiscale);
it.messages = Object.assign({}, it.messages, { codiceFiscale: field => 'Codice Fiscale non valido.' });

// VEE VALIDATE CONFIG
const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: {
	  it: it
  },
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'it',
  validity: false,
  useConstraintAttrs: true
};

export default {
	config,
	core: VeeValidate
}



// WEBPACK FOOTER //
// ./src/utils/vee-validate/index.js